import { useQuery } from "@tanstack/react-query";
import { BRIEF_TOTAL_AGGREGATION_QUERY_KEY } from "../constants";
import { BriefService } from "../services/brief.service";

export function useGetBriefTotalAggregation(briefId: string) {
  const { data, isFetching } = useQuery({
    queryKey: [...BRIEF_TOTAL_AGGREGATION_QUERY_KEY, briefId],
    queryFn: () => BriefService.getBriefTotalAggregation(briefId),
  });

  return {
    aggregation: data?.data,
    isFetching,
  };
}
